import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ImageDialogData {
  src: string;
  title?: string;
  alt?: string;
}

@Component({
  selector: 'app-image-dialog',
  templateUrl: './image-dialog.component.html',
  styleUrls: ['./image-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageDialogComponent implements OnInit {

  config: ImageDialogData;

  imageLoaded: boolean;

  constructor(
    private dialogRef: MatDialogRef<ImageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: ImageDialogData,
    private changeRef: ChangeDetectorRef
  ) {
    this.config = data;
  }

  ngOnInit() {
  }

  handleCloseClick() {
    this.dialogRef.close();
  }

  handleImageLoaded() {
    this.imageLoaded = true;
    this.changeRef.markForCheck();
  }

}
